import React, { Component } from 'react'; 
import { Link } from "react-router-dom";
class Fisica extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Juega con la Fisica</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
            <iframe align="center" frameborder="0" allowtransparency="true" title='Fisica' src="https://spritted.com/en/game/physics-drop?embed" width="1080px" height="720px"></iframe>
            </h2>
            </div>
        
          </div>
            <div>
            <div className="containerjuego">
                <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default Fisica;